<template>
  <odd-page title="Customizations Editor" :subtitle="name">
    <template v-slot:header>
      <div class="w-100 d-flex flex-row justify-content-end align-items-center">
        <d-dropdown
          theme="dark"
          size="sm"
          noCaret
          class="mx-2 radius"
          round
          right
          closeOnClick
        >
          <template v-slot:button-content>
            <i class="material-icons">more_horiz</i>
          </template>
          <template>
            <d-dropdown-item
              v-if="uses_post_purchase_content"
              @click="handleEditPostPurchaseContent()"
              tag="button"
              :icon="add"
              :iconTheme="primary"
              class="btn-sm"
            >
              Edit Post Purchase Content
            </d-dropdown-item>
            <d-dropdown-item
              v-if="uses_post_purchase_content"
              @click="handleEditPostPurchaseEmail()"
              tag="button"
              :icon="add"
              :iconTheme="primary"
              class="btn-sm"
            >
              Edit Post Purchase Email
            </d-dropdown-item>
            <d-dropdown-item
              @click="handleEditProduct()"
              tag="button"
              :icon="add"
              :iconTheme="primary"
              class="btn-sm"
            >
              Edit Product
            </d-dropdown-item>
          </template>
        </d-dropdown>
      </div>
    </template>
    <template>
      <div v-if="loading">
        <div class="w-100 py-5 text-center">
          <odd-spinner class="mx-auto" />
        </div>
      </div>
      <div v-else>
        <CustomizationEditor
          :customizations="customizations"
          :onSave="handleCustomizationsSave"
        />
      </div>
    </template>
  </odd-page>
</template>

<script>
import CustomizationEditor from "../../components/CustomizationEditor";
import Page from "@/components/layout/Page/Page.vue";
import Vue from "vue";

export default {
  data() {
    return {
      loading: false
    };
  },
  created() {
    this.loading = true;
    this.$store.dispatch("products/get", this.$route.params.key).then(data => {
      this.loading = false;
    });
  },
  computed: {
    name() {
      return !!this.$store.state.products.editProduct
        ? this.$store.state.products.editProduct.name
        : "  ";
    },
    customizations() {
      return !!this.$store.state.products.editProduct
        ? this.$store.state.products.editProduct.customizations
        : "";
    },
    uses_post_purchase_content() {
      return this.$store.getters["settings/uses_post_purchase_content"];
    },
    uses_customizations() {
      return this.$store.getters["settings/uses_customizations"];
    }
  },
  components: { CustomizationEditor, "odd-page": Page },
  methods: {
    copyToClipboard(str) {
      const el = document.createElement("textarea");
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$toasted.show(`Copied ${str} to clipboard`, {
        position: "bottom-right",
        duration: 2000
      });
    },
    handleCustomizationsSave(customizations) {
      this.loading = true;
      const updatedProduct = {
        key: this.$route.params.key,
        customizations: customizations
      };
      this.$store.dispatch("products/update", updatedProduct).then(data => {
        this.loading = false;
        this.$toasted.show(`Customizations updated successfully`, {
          position: "bottom-right",
          duration: 2000
        });
      });
    },
    handleEditProduct() {
      this.$router.push({
        name: "products__edit",
        params: { key: this.$route.params.key }
      });
    },
    handleEditPostPurchaseContent() {
      this.$router.push({
        name: "products__edit__post_purchase_content",
        params: { key: this.$route.params.key }
      });
    },
    handleEditPostPurchaseEmail() {
      this.$router.push({
        name: "products__edit__post_purchase_email",
        params: { key: this.$route.params.key }
      });
    }
  }
};
</script>